var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77093 5.77093C5.62422 5.91761 5.42526 6 5.2178 6C5.01035 6 4.81139 5.91761 4.66467 5.77093L0.238846 1.34511C0.164123 1.27294 0.104521 1.18661 0.0635177 1.09116C0.0225148 0.995705 0.000932303 0.893043 2.96013e-05 0.789161C-0.000873101 0.685279 0.0189222 0.582259 0.0582601 0.486109C0.097598 0.389959 0.155691 0.302607 0.229149 0.229148C0.302607 0.15569 0.389959 0.0975976 0.486109 0.0582595C0.582258 0.0189214 0.68528 -0.000873558 0.789161 2.95733e-05C0.893043 0.000932227 0.995704 0.0225144 1.09116 0.0635176C1.18661 0.10452 1.27294 0.164122 1.34511 0.238846L5.2178 4.11154L9.0905 0.238846C9.23806 0.0963322 9.43568 0.0174743 9.64081 0.0192567C9.84595 0.0210396 10.0422 0.10332 10.1872 0.248376C10.3323 0.393433 10.4146 0.589659 10.4164 0.794792C10.4181 0.999925 10.3393 1.19755 10.1968 1.34511L5.77093 5.77093Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlue);
export default __webpack_public_path__ + "static/media/down_arrow_blue.d333af1f0437d20a8b3c457ec3e43727.svg";
export { ForwardRef as ReactComponent };